declare global {
    interface Window { API_BASE_URL: string }
}

const getApiBaseUrl = (): string => {
    // On tenant subdomains, use relative path so cookies align with the domain
    if (window.location.hostname.endsWith('.postles.app')) return '/api'

    return window.API_BASE_URL
        || (process.env.REACT_APP_API_BASE_URL ?? '/api')
}

export const env = {
    api: {
        baseURL: getApiBaseUrl(),
    },
}
